import { render } from "./FooterBar.vue?vue&type=template&id=5dff6f73&scoped=true"
import script from "./FooterBar.vue?vue&type=script&lang=js"
export * from "./FooterBar.vue?vue&type=script&lang=js"

import "./FooterBar.vue?vue&type=style&index=0&id=5dff6f73&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dff6f73"]])

export default __exports__